export const defaultPermission = {
    name: "all",
    label: "All (default)",
    description: "",
    flags: [],
    roles: [],
    user_functions: [],
};

export const columns = [
    {
        id: 2,
        name: "Drax Executive",
        ldPermissions: ["Adapt"],
        pacePermissions: ["Executive Evaluation"],
        usersCount: 3,
        crmId: 1,
        createdOn: "2024-07-12",
    },
    {
        id: 3,
        name: "Rowan Group",
        ldPermissions: ["Adapt"],
        pacePermissions: ["Executive Evaluation"],
        usersCount: 4,
        crmId: 2,
        createdOn: "2024-07-12",
    },
];

export const tableHeaderConfig: {
    id: string | number;
    name: string;
    isHidable: boolean;
    isSortableByBestMatch?: boolean;
    isSortableByDate?: boolean;
    sort?: { isSortableByBestMatch?: boolean; sortBy?: "date" | "a-z" | "numeric" };
    isHidden?: boolean;
    sx: React.CSSProperties;
}[] = [
    {
        id: "name",
        name: "Client Hubs",
        isHidable: false,
        sort: { isSortableByBestMatch: false, sortBy: "a-z" },
        sx: { width: "20%" },
    },
    {
        id: "roles_ld",
        name: "LD Permissions",
        isHidable: false,
        sx: { width: 140 },
    },
    {
        id: "roles_pace",
        name: "PACE Permissions",
        isHidable: false,
        sx: { width: 200 },
    },
    {
        id: "users_count",
        name: "Users",
        isHidable: true,
        isHidden: false,
        sort: { isSortableByBestMatch: false, sortBy: "numeric" },
        sx: { width: 65 },
    },
    {
        id: "crm_id",
        name: "CRM Link",
        isHidable: true,
        isHidden: false,
        sx: { width: 140 },
    },
    {
        id: "created_utc",
        name: "Date Created",
        sort: { isSortableByBestMatch: false, sortBy: "date" },
        isHidable: true,
        isHidden: false,
        sx: { width: "15%" },
    },
];
